import {Injectable} from "@angular/core";

declare var $: any;

@Injectable()
export class Offcanvas {
  /*  offcanvas  start */

  _timer = null;
  _useBackdrop = null;

  handleOffcanvasClose() {
    this.closeOffcanvas();
    this.invalidate();
  }

  invalidate() {
    this.toggleButtonState();
    this.toggleBackdropState();
    this.toggleBodyScrolling();
    this.evalScrollbar();
  };

  toggleButtonState() {
    // Activate the active offcanvas pane
    var id = $('.offcanvas-pane.active').attr('id');
    $('[data-toggle="offcanvas"]').removeClass('active');
    $('[href="#' + id + '"]').addClass('active');
  };

  evalScrollbar() {
    if (!$.isFunction($.fn.nanoScroller)) {
      return;
    }

    // Check if there is a menu
    var menu = $('.offcanvas-pane.active');
    if (menu.length === 0)
      return;

    // Get scrollbar elements
    var menuScroller = $('.offcanvas-pane.active .offcanvas-body');
    var parent = menuScroller.parent();

    // Add the scroller wrapper
    if (parent.hasClass('nano-content') === false) {
      menuScroller.wrap('<div class="nano"><div class="nano-content"></div></div>');
    }

    // Set the correct height
    var height = $(window).height() - menu.find('.nano').position();
    var scroller = menuScroller.closest('.nano');
    scroller.css({height: height});

    // Add the nanoscroller
    scroller.nanoScroller({preventPageScrolling: true});
  };

  toggleBackdropState() {
    // Clear the timer that removes the keyword
    if ($('.offcanvas-pane.active').length > 0 && this._useBackdrop) {
      this.addBackdrop();
    }
    else {
      this.removeBackdrop();
    }
  };

  addBackdrop() {
    if ($('#base > .backdrop').length === 0 && $('#base').data('backdrop') !== 'hidden') {
      $('<div class="backdrop"></div>').hide().appendTo($('body').find('#base')).fadeIn();
    }
  };

  removeBackdrop() {
    $('#base > .backdrop').fadeOut(function () {
      $(this).remove();
    });
  };

  measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    $('body').append(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    $('body')[0].removeChild(scrollDiv);
    return scrollbarWidth;
  };

  toggleBodyScrolling() {
    clearTimeout(this._timer);
    if ($('.offcanvas-pane.active').length > 0 && this._useBackdrop) {
      // Add body padding to prevent visual jumping
      var scrollbarWidth = this.measureScrollbar();
      var bodyPad = parseInt(($('body').css('padding-right') || 0), 10);
      if (scrollbarWidth !== bodyPad) {
        $('body').css('padding-right', bodyPad + scrollbarWidth);
        $('.headerbar').css('padding-right', bodyPad + scrollbarWidth);
      }
    }
    else {
      this._timer = setTimeout(function () {
        // Remove offcanvas-expanded to enable body scrollbar
        $('body').removeClass('offcanvas-expanded');
        $('body').css('padding-right', '');
        $('.headerbar').removeClass('offcanvas-expanded');
        $('.headerbar').css('padding-right', '');
      }, 330);
    }
  };

  handleOffcanvasOpen(canvasId) {

    var btn = $(canvasId);
    // When the button is active, the off-canvas is already open and sould be closed
    if (btn.hasClass('active')) {
      this.handleOffcanvasClose();
      return;
    }

    // Set data variables
    this._useBackdrop = (btn.data('backdrop') === undefined) ? true : btn.data('backdrop');
    // Open off-canvas
    this.openOffcanvas(canvasId);
    this.invalidate();
  };

  closeOffcanvas() {
    // Remove expanded on all offcanvas buttons
    $('body').find('[data-toggle="offcanvas"]').removeClass('expanded');

    // Remove offcanvas active state
    $('body').find('.offcanvas-pane').removeClass('active');//.removeAttr('style');
    $('body').find('.offcanvas-pane').css({
      '-webkit-transform': '',
      '-ms-transform': '',
      '-o-transform': '',
      'transform': ''
    });
    this.disableEvents(null);
  }

  openOffcanvas(id) {


    this.closeOffcanvas();
    this.enableEvents(id);
    // Activate selected offcanvas pane
    var btn = $('body').find(id);
    btn.addClass('active');
    // Set data variables
    this._useBackdrop = (btn.data('backdrop') === undefined) ? true : btn.data('backdrop');
    // Check if the offcanvas is on the left
    var leftOffcanvas = ($('body').find(id).closest('.offcanvas:first').length > 0);

    // Remove offcanvas-expanded to enable body scrollbar
    if (this._useBackdrop)
      $('body').addClass('offcanvas-expanded');

    // Define the width
    var width = $(id).width();
    if (width > $(document).width()) {
      width = $(document).width() - 8;
      $(id + '.active').css({'width': width});
    }
    width = (leftOffcanvas) ? width : '-' + width;

    // Translate position offcanvas pane
    var translate = 'translate(' + width + 'px, 0)';

    $(id + '.active').css({
      '-webkit-transform': translate,
      '-ms-transform': translate,
      '-o-transform': translate,
      'transform': translate
    });

  }

  enableEvents(id) {
    var o = this;

    // Window events
    $(window).on('resize', function (e) {
      o.evalScrollbar();
    });

    // Offcanvas events
    $('.offcanvas').on('refresh', function (e) {
      o.evalScrollbar();
    });
    $('[data-toggle="offcanvas"]').on('click', function (e) {
      e.preventDefault();
      o.handleOffcanvasOpen($(e.currentTarget));
    });
    $('[data-dismiss="offcanvas"]').on('click', function (e) {
      o.handleOffcanvasClose();
    });
    $('#base').on('click', '> .backdrop', function (e) {
      o.handleOffcanvasClose();
    });

    // Open active offcanvas buttons
    $('[data-toggle="offcanvas-left"].active').each(function () {
      o.handleOffcanvasOpen($(this).attr("id"));
    });
    $('[data-toggle="offcanvas-right"].active').each(function () {
      o.handleOffcanvasOpen($(this).attr("id"));
    });
  };

  disableEvents(id) {
    var o = this;

    // Window events
    $(window).unbind('resize');

    // Offcanvas events
    $('.offcanvas').unbind('refresh');
    $('[data-toggle="offcanvas"]').unbind('click');
    $('[data-dismiss="offcanvas"]').unbind('click');
    $('#base').unbind('click', '> .backdrop');

  };

  /* offcanvas end */
}
